export const normalizeURL = (rawUrl: string) => {
  try {
    // Trim input and add protocol if missing
    let url = rawUrl.trim();
    if (!/^https?:\/\//i.test(url)) {
      url = 'http://' + url;
    }

    const { hostname } = new URL(url);

    // Ensure there's a valid hostname
    if (!hostname || hostname.includes(' ')) {
      return null;
    }

    // Normalize to www.site.com
    let normalized = hostname.toLowerCase();
    if (!normalized.startsWith('www.')) {
      normalized = 'www.' + normalized.replace(/^www\./, '');
    }

    return normalized;
  } catch (err) {
    return null; // Invalid URL
  }
};

const TRACKING_QUERY_PARAM_PREFIXES = ['utm_'];
const TRACKING_QUERY_PARAMS = new Set([
  'dclid',
  'fbclid',
  'gbraid',
  'gclid',
  'igshid',
  'mc_cid',
  'mc_eid',
  'msclkid',
  'rb_clickid',
  'twclid',
  'wbraid',
]);

export const normalizeCommunityWebsiteUrl = (rawUrl?: string | null) => {
  const originalUrl = rawUrl ?? '';
  let url = originalUrl.trim();

  if (!url) {
    return '';
  }

  if (/\s/.test(url)) {
    return originalUrl;
  }

  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }

  try {
    const urlObject = new URL(url);
    if (!['http:', 'https:'].includes(urlObject.protocol) || !urlObject.hostname) {
      return originalUrl;
    }

    if (urlObject.username || urlObject.password) {
      return originalUrl;
    }

    const protocol = urlObject.protocol.toLowerCase();
    const hostname = urlObject.hostname.toLowerCase();
    const port = urlObject.port ? `:${urlObject.port}` : '';
    const pathname = urlObject.pathname === '/' ? '' : urlObject.pathname.replace(/\/+$/, '');
    const searchParams = new URLSearchParams(urlObject.search);
    [...searchParams.keys()].forEach((key) => {
      const normalizedKey = key.toLowerCase();
      const isTrackingParam =
        TRACKING_QUERY_PARAMS.has(normalizedKey) ||
        TRACKING_QUERY_PARAM_PREFIXES.some((prefix) => normalizedKey.startsWith(prefix));

      if (isTrackingParam) {
        searchParams.delete(key);
      }
    });
    const query = searchParams.toString();

    return `${protocol}//${hostname}${port}${pathname}${query ? `?${query}` : ''}`;
  } catch (err) {
    return originalUrl;
  }
};

export const joinUrl = (base: string, path: string) => new URL(path, base.endsWith('/') ? base : `${base}/`).toString();
